import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { SwitchCategoryButton } from '../../shared/SwitchCategoryButton';

interface TrafficAnalyticsCategoryProps {
    category: string;
    selectCategory: (cat: string) => void;
    categories: CategoryMenu[];
}

export interface CategoryMenu {
    name: string;
    label: string;
}

export default function TrafficAnalyticsCategoryMenu({ category, selectCategory, categories }: TrafficAnalyticsCategoryProps) {

    return (
        <Box sx={{
            display: 'flex',
            mb: {
                xs: 2,
                md: 2,
                lg: 0,
                xl: 0
            }

        }}>
            <Box sx={{
                position: 'relative',
                pl: {
                    xs: 1,
                    sm: 3,
                    md: 3
                },
                pr: {
                    xs: 1,
                    sm: 0,
                    md: 0
                },
                backgroundColor: 'action.active', borderRadius: 2, flexGrow: 0, alignItems: 'flex-start',
                display: 'flex',
                flexDirection: {
                    xs: 'column',
                    sm: 'row',
                    md: 'row'
                }
            }}
            >
                <SwitchCategoryButton name='live' sx={{ color: 'white', fontWeight: 'bold', mr: 2 }} active={false}>Live</SwitchCategoryButton>
                <Typography sx={{
                    fontSize: 30,
                    fontWeight: 900,
                    marginLeft: '-25px',
                    zIndex: 10,
                    verticalAlign: 'super',
                    display: 'block',
                    position: 'absolute',
                    left: 112,
                    top: -12,
                    color: 'secondary.main'
                }}>&middot;</Typography>
                
                <SwitchCategoryButton onClick={() => selectCategory('byweek')} active={category === 'byweek'} name='byweek'>By Week</SwitchCategoryButton>
                <SwitchCategoryButton onClick={() => selectCategory('bytime')} active={category === 'bytime'} name='bytime'>By Time</SwitchCategoryButton>
                <SwitchCategoryButton onClick={() => selectCategory('bydemographics')} active={category === 'bydemographics'} name='bydemographics'>By Demographics</SwitchCategoryButton>

            </Box>
        </Box>

    )
}
